/*!
 * vue-multiselect v0.1.20
 * (c) 2016 Damian Dulisz
 * Released under the MIT License.
 */
import Multiselect from './Multiselect.vue'
import multiselectMixin from './multiselectMixin.js'
import pointerMixin from './pointerMixin.js'

export default Multiselect

export {Multiselect, multiselectMixin, pointerMixin}